// Others
import axiosClient from './axiosClient';
import { IFormIncident } from '~/utils/interface/incident';
import { IBaseResponse } from '~/utils/interface/base';
import { urlApiIncident } from '~/utils/constants/apis';

const incidentApi = {
  deleteIncident: (id: string) => {
    const url = urlApiIncident.deleteIncident(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createIncident: (body: IFormIncident) => {
    const url = urlApiIncident.createIncident;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default incidentApi;
